import React from 'react';

import { Inline, Fullscreen, RappiGif } from './styles';

interface Props {
  fullScreen?: boolean;
  className?: string;
}

const Loader = ({ fullScreen, className }: Props) => {
  const Container = fullScreen ? Fullscreen : Inline;

  return (
    <Container className={className || ''} data-testid={`loading-${fullScreen ? 'fullscreen' : 'inline'}`}>
      <RappiGif src="/images/logo-orange-loading.gif" alt="rappi-logo" />
    </Container>
  );
};

export default Loader;
